import script from "./VoucherAmountPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoucherAmountPage.vue?vue&type=script&setup=true&lang=ts"

import "./VoucherAmountPage.vue?vue&type=style&index=0&id=73af6d44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73af6d44"]])

export default __exports__